import React from "react";
import {Card} from "antd";
import {useParams} from "react-router-dom";
import {t} from "i18next";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import WorklistItemCreateEdit from "../../app/worklist-item/WorklistItemCreateEdit";

function WorklistItemCreateEditPage()
{
    const {worklistItemId} = useParams();
    const isEdit = !!worklistItemId;

    return (
        <LayoutWithSider
            content={
                <Card title={isEdit ? t('EditWorklistItem') : t('NewWorklistItem')}>
                    <WorklistItemCreateEdit worklistItemId={worklistItemId}/>
                </Card>
            }
        />
    )
}

export default WorklistItemCreateEditPage;
